"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RETRY_IDEAL = exports.DEFAULT_RETRY_TIMES = exports.DEFAULT_IDEAL = void 0;
var DEFAULT_IDEAL = 10 * 60 * 1000; // 10min
exports.DEFAULT_IDEAL = DEFAULT_IDEAL;
var DEFAULT_RETRY_TIMES = 3;
exports.DEFAULT_RETRY_TIMES = DEFAULT_RETRY_TIMES;
var RETRY_IDEAL = 30 * 1000; // 30s
exports.RETRY_IDEAL = RETRY_IDEAL;
exports.default = {};
//# sourceMappingURL=index.js.map